import React from 'react';
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/lib/Async'
// https://react-select.com/async#loading-asynchronously
import client from '../../helpers/client'
import CustomOption from './CustomOption'
import './index.scss'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    fontSize: 18,
    paddingLeft: 10
  })
}

const deserializeEvent = (event) => {
  if(event && event.id && event.attributes) {
    return {
      value: event.id,
      label: event.attributes.title,
      attributes: event.attributes
    }
  }
  else {
    return null
  }
}

const deserializeEvents = (serializedEvents) => {
  return serializedEvents.map(event => deserializeEvent(event)).filter(event => event)
}



class EventDropdown extends React.Component {
  static propTypes = {
    events: PropTypes.array,
    inputId: PropTypes.string,
    selected: PropTypes.object,
    apiKey: PropTypes.string.isRequired,
    connectionId: PropTypes.string
  }

  static defaultProps = {
    events: []
  }

  state = {
    selectedOption: deserializeEvent(this.props.selected),
    currentValue: ""
  }

  componentDidMount() {
    const { inputId } = this.props

    if(inputId) {
      this.input = document.getElementById(inputId)
      this.syncHtmlInput()
    }
  }

  handleInputChange = (currentValue) => {
    this.setState({ currentValue })
  }

  handleChange = (selectedOption) => {
    console.log({ selectedOption })
    this.setState({ selectedOption }, () => this.syncHtmlInput())

  }

  syncHtmlInput() {
    const { selectedOption } = this.state

    if(this.input) {
      if(selectedOption) {
        this.input.value = selectedOption.value
      }
      else {
        this.input.value = ""
      }
    }
  }

  handleLoadOptions = (inputValue, callback) => {
    const { apiKey, connectionId } = this.props
    const { currentValue } = this.state

    client.get(`/api/v1/events/autocomplete.json?api_key=${apiKey}&text=${currentValue}`)
      .then(response => {
        const options = deserializeEvents(response.data.data)
        callback(options)
      })
      .catch(error => {
        const { data, status } = error.response
        const { errors } = data
        const errorMessage = status === 422 ? errors.join(", ") : "Error contacting server"
        alert(errorMessage)
      })
  }



  render() {
    const { events } = this.props
    const { selectedOption, currentValue } = this.state;

    return (
      <AsyncSelect
        cacheOptions
        name={"event_id"}
        loadOptions={this.handleLoadOptions}
        components={{ Option: CustomOption }}
        onInputChange={this.handleInputChange}
        onChange={this.handleChange}
        styles={customStyles}
        placeholder="Start typing..."
        noOptionsMessage={() => currentValue ? "Unable to find any matching bookings" : "Start typing to search for bookings"}
        defaultOptions={deserializeEvents(events)}
        value={selectedOption}
        isClearable={true}
      />
    );
  }
}

export default EventDropdown
